<template>
    <div
        class="VFilter"
        :class="filterClasses"
        @mouseover="catchVFilterEvent"
    >
        <div
            class="VFilter-title"
            @click="changeDropdownVisabillity()"
        >
            <VButton :is-active="isShowDropdown">
                <slot>
                    {{ title }}
                </slot>
            </VButton>
        </div>
        <ul
            class="VFilter-dropdown"
            :class="`VFilter-dropdown_${itemsType}`"
            v-if="isShowDropdown && !byProperty"
            v-click-outside="hideDropdown"
        >
            <template v-if="itemsType === 'checkboxes'">
                <template v-for="(option,optionIndex) in options">
                    <li
                        v-if="!groupProperties.includes(option[uniqueProperty])"
                        :key="optionIndex"
                        class="VFilter-dropdown-row"
                        @click="clickDropdownRow(option)"
                    >
                    <span
                        @click.stop="changeCheckboxState(option[uniqueProperty])"
                    >
                    <VCheckbox
                        :checked="uniqueProperties.includes(option[uniqueProperty])"
                    >
                    </VCheckbox>
                        </span>
                        <span class="VFilter-dropdown-row__option"> {{ option[showProperty] }}</span>
                    </li>
                </template>
                <template
                    v-for="(group,groupIndex) in localGroups"
                >
                    <div
                        class="VFilter-dropdown-group"
                        v-if="group.options.length"
                        :key="`group-${groupIndex}`"
                    >{{ group.name }}
                    </div>
                    <li
                        v-for="(option,optionIndex) in group.options"
                        :key="`groupItem-${optionIndex}`"
                        class="VFilter-dropdown-row"
                        @click="clickDropdownRow(option)"
                    >
                        <span
                            @click.stop="changeCheckboxState(option[uniqueProperty])"
                        >
                            <VCheckbox
                                :checked="uniqueProperties.includes(option[uniqueProperty])"
                            >
                            </VCheckbox>
                        </span>
                        <span class="VFilter-dropdown-row__option"> {{ option[showProperty] }} </span>
                        <span
                            class="VFilter-dropdown-row__icon"
                            :style="{ backgroundImage: 'url(' + group.icon + ')' }"
                        ></span>
                    </li>
                </template>
            </template>
            <template v-if="itemsType === 'images'">
                <template v-if="!isGrouped">
                    <li
                        class="VFilter-dropdown-item"
                        :style="{'background-image':`url(${option[imageProperty]})`}"
                        :class="{'VFilter-dropdown-item_disabled': !uniqueProperties.includes(option[uniqueProperty])}"
                        v-for="(option,optionIndex) in options"
                        :key="optionIndex"
                        @click="changeCheckboxState(option[uniqueProperty])"
                        @mouseover="showTooltip($event,'appTooltip',option)"
                    >
                    </li>
                </template>
                <template v-else>
                    <div
                        v-for="(group, groupIndex) in groupedImageTypeItems"
                        :key="groupIndex"
                        class="VFilter-dropdown-group-of-images"
                    >
                        <div class="VFilter-dropdown-group-of-images__label">
                            {{ group.groupName }}
                        </div>
                        <VInput
                            v-if="isShowSearch"
                            v-model="searchInput"
                            :placeholder="'Search...'"
                        ></VInput>
                        <div
                            class="VFilter-dropdown-group-of-images__select-all"
                            @click="selectAll(group, group.isSelectedAll)"
                        >
                            Select All
                            <VCheckbox
                                :checked="group.isSelectedAll"
                            >
                            </VCheckbox>
                        </div>
                      <div class="VFilter-osgroup" v-for="(osgroup,osgroupIndex) in group.osGroups" :key="osgroupIndex">
                        <div class="VFilter-osgroup__label">
                          {{ osgroup.os }}
                        </div>
                        <div class="VFilter-osgroup__items">
                          <template v-for="(option,optionIndex) in osgroup.items">
                            <span
                                v-if="filteredOptionsUniqueNames.includes(option[uniqueProperty])"
                                style="position: relative"
                                :key="optionIndex"
                            >
                              <li
                                  class="VFilter-dropdown-item"
                                  :style="{'background-image':`url(${option[imageProperty]})`}"
                                  :class="{'VFilter-dropdown-item_disabled': !uniqueProperties.includes(option[uniqueProperty])}"
                                  @click="changeCheckboxState(option[uniqueProperty])"
                                  @mouseover="showTooltip($event,'appTooltip',option)"
                              >
                              </li>
                            </span>
                          </template>
                        </div>
                      </div>

                    </div>
                </template>
            </template>
        </ul>
        <ul
            class="VFilter-dropdown"
            v-if="isShowDropdown && byProperty"
            v-click-outside="hideDropdown"
        >
            <li
                v-for="(option,optionIndex) in options"
                :key="optionIndex"
                @change="changeCheckboxStateByProperty(optionIndex)"
            >
                <VCheckbox
                    :checked="uniqueProperties.isActive"
                >
                </VCheckbox>
                {{ option[showProperty] }}
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'VFilter',
        model: {
            prop: 'items',
            event: 'updateItems',
        },
        props: {
            title: {
                type: String,
                default: () => '',
            },
            options: {
                type: Array,
                required: true,
                default: () => [],
            },
            groups: {
                type: Array,
                required: false,
                default: () => [],
            },
            items: {
                type: Array,
                required: true,
                default: () => [],
            },
            showProperty: {
                type: String,
                default: 'name',
            },
            uniqueProperty: {
                type: String,
                default: 'name',
            },
            imageProperty: {
                type: String,
                default: 'logo',
                required: false,
            },
            byProperty: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            itemsType: {
                type: String,
                default: 'checkboxes',
                validator: function (value) {
                    return ['checkboxes', 'images'].includes(value);
                },
            },
            highlightElementName: {
                type: String,
                default: '',
            },
            isCatchEvent: {
                type: Boolean,
                default: false,
            },
            isGrouped: {
                type: Boolean,
                default: false,
            },
            groupLabel: {
                type: String,
                default: '',
            },
            isShowSearch: {
              type: Boolean,
              default: false,
            },
            filterProperties: {
              type: Array,
              default: () => [],
            },
        },
        data() {
            return {
                isShowDropdown: false,
                filterChangesIndexes: [],
                searchInput: '',
            };
        },
        computed: {
            filteredOptionsUniqueNames() {
              if (!this.searchInput || !this.filterProperties.length) {
                return this.options.map((item) => item[this.uniqueProperty]);
              }
              const searchInputLower = this.searchInput.toLowerCase();
              return this.options.filter((option) => {
                return this.filterProperties.some((prop) => {
                  const value = option[prop];
                  if (value && typeof value === 'string') {
                    return value.toLowerCase().includes(searchInputLower);
                  }
                  return false;
                });
              }).map((item) => item[this.uniqueProperty]);
            },
            filterClasses() {
                const classes = [];
                if (this.disabled) {
                    classes.push('disabled');
                }
                return classes;
            },
            uniqueProperties() {
                return this.items.map((item) => item[this.uniqueProperty]);
            },
            groupProperties() {
                return this.groups.flatMap((group) => group.optionNames);
            },
            localGroups() {
                const groups = [];
                this.groups.forEach((group) => {
                    const groupOptions = [];
                    group.optionNames.forEach((optionName) => {
                        const option = this.options.find((option) => option.name === optionName);
                        if (option) {
                            groupOptions.push(option);
                        }
                    });
                    groups.push({
                        name: group.name,
                        options: groupOptions,
                        icon: group.icon,
                    });
                });
                return groups;
            },
          groupedImageTypeItems() {
            // Initialize groups based on groupLabel
            const groups = this.options.map((option) => ({
              groupName: option[this.groupLabel],
              osGroups: [],
              isSelectedAll: false,
            })).filter((item, index, arr) =>
                arr.findIndex((group) => group.groupName === item.groupName) === index
            );

            // Iterate over options to populate osGroups within each group
            this.options.forEach((option) => {
              const correctGroup = groups.find((group) => group.groupName === option[this.groupLabel]);
              const os = option.os;

              // Find or create the osGroup within the correct group
              let osGroup = correctGroup.osGroups.find((osGroup) => osGroup.os === os);
              if (!osGroup) {
                osGroup = { os: os, items: [] };
                correctGroup.osGroups.push(osGroup);
              }
              osGroup.items.push(option);
            });

            // Update isSelectedAll based on all items within the group
            groups.forEach((group) => {
              const allItems = group.osGroups.flatMap(osGroup => osGroup.items);
              group.isSelectedAll = allItems.every((item) =>
                  this.uniqueProperties.includes(item[this.uniqueProperty])
              );
            });

            return groups;
          },
        },
        methods: {
            changeDropdownVisabillity() {
                if (!this.disabled) {
                    if (this.isShowDropdown) {
                        this.hideDropdown();
                    } else {
                        this.isShowDropdown = true;
                    }
                }
            },
            hideDropdown() {
                this.isShowDropdown = false;
                this.searchInput = '';
                if (this.filterChangesIndexes.length) {
                    this.$emit('closed', !!this.filterChangesIndexes.length);
                }
                this.filterChangesIndexes = [];
            },
            clickDropdownRow(option) {
                this.$emit('clickDropdownRow', option);
            },
            changeCheckboxState(optionName) {
                const checkBoxIndex = this.options.findIndex((option) => option[this.uniqueProperty] === optionName);
                const isNeedAdd = !this.uniqueProperties.includes(optionName);
                const newItems = _.cloneDeep(this.items);
                if (isNeedAdd) {
                    newItems.push(this.options[checkBoxIndex]);

                } else {
                    const itemIndex = this.isGrouped ? newItems.findIndex((item) => item[this.uniqueProperty] ===
                        this.options[checkBoxIndex][this.uniqueProperty]) : newItems.findIndex((item) =>
                        item[this.uniqueProperty] ===
                        this.options[checkBoxIndex][this.uniqueProperty]);
                    newItems.splice(itemIndex, 1);

                }
                if (this.filterChangesIndexes.includes(checkBoxIndex)) {
                    this.filterChangesIndexes = this.filterChangesIndexes.filter((index) => index !==
                        checkBoxIndex);
                } else {
                    this.filterChangesIndexes.push(checkBoxIndex);
                }
                this.$emit('updateItems', newItems);
            },
            selectAll(group, isSelectedAll) {
                const groupItems = group.osGroups.flatMap((osGroup) => osGroup.items);
                const newItems = _.cloneDeep(this.items);
                const itemsToChange = isSelectedAll ? groupItems : groupItems.filter((item) => !this.uniqueProperties.includes(item[this.uniqueProperty]));
                itemsToChange.forEach((item) => {
                    const checkBoxIndex = this.options.findIndex((option) => option[this.uniqueProperty] === item[this.uniqueProperty]);
                    if (isSelectedAll) {
                        const itemIndex = newItems.findIndex((item) => item[this.uniqueProperty] === this.options[checkBoxIndex][this.uniqueProperty]);
                        newItems.splice(itemIndex, 1);
                    } else {
                        newItems.push(this.options[checkBoxIndex]);
                    }
                    if (this.filterChangesIndexes.includes(checkBoxIndex)) {
                        this.filterChangesIndexes = this.filterChangesIndexes.filter((index) => index !==
                            checkBoxIndex);
                    } else {
                        this.filterChangesIndexes.push(checkBoxIndex);
                    }
                });
                this.$emit('updateItems', newItems);
            },
            changeCheckboxStateByProperty() {
                const newItems = this.items;
                this.$emit('updateItems', newItems);
            },
            showTooltip(event, tooltipFunctionName, data) {
                this.$emit('showTooltip', event, tooltipFunctionName, data);
            },
            catchVFilterEvent(event) {
                if (this.isCatchEvent && event.target.classList.contains('VFilter-dropdown-row')) {
                    const self = this;
                    const addMouseOutListener = function (el) {
                        const listener = () => {
                            self.$emit('catchEvent', event, false);
                            el.removeEventListener('mouseleave', listener, false);
                        };
                        el.addEventListener('mouseleave', listener, false);
                    };

                    this.$emit('catchEvent', event, true);
                    addMouseOutListener(event.target);
                }
            },
        },
    };

</script>

<style
    scoped
    lang="scss"
>
    .VFilter {

      ::v-deep {
        input {
          width: 100px;
        }
      }
        position: relative;

        //::v-deep .VCheckbox, .VFilter-dropdown-row__option {
        //    pointer-events: none;
        //}

        &-title {

        }

        &-osgroup {
          width: 100%;

          &__label {
            text-transform: capitalize;
            font-weight: 700;
            text-align:left ;
            padding-left: 5px;
          }

          &__items {
            display: flex;
            flex-wrap: wrap;
          }
        }


        &-dropdown {
            position: absolute;
            z-index: $dropdown-z-index;
            background: #FFFFFF;
            min-width: 154px;
            max-height: 190px;
            overflow: auto;
            border-radius: 5px;
            border-bottom: 10px solid #FFFFFF;
            border-top: 10px solid #FFFFFF;
            @include scrollbar-styles;
            @include default-shadow;

            &-group {
                padding: 20px;
                font-weight: bold;
            }

            &-group-of-images {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 20px;
                width: 100%;

                &:last-child {
                    margin-bottom: 0;
                }

                &__label {
                    //width: calc(50% - 5px);
                    width: 100px;
                    display: flex;
                    align-items: center;
                    text-align: left;
                    padding-left: 5px;
                    font-weight: 700;
                    margin-bottom: 5px;
                }

                &__select-all {
                    width: 35%;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    gap: 10px;
                }
            }

            &-item {
                border: 2px solid $primary-color;

                &_disabled {
                    filter: grayscale($disabled-grayscale);
                    border: 2px solid #FFFFFF;
                }

              &-os {
                height: 10px;
                color: white;
                background: rgba(0, 0, 0, 0.5);
                position: absolute;
                top: 7px;
                width: 35px;
                left: 7px;
                border-radius: 3px 3px 0 0;
                font-size: 9px;
              }
            }

            &_images {
                display: flex;

                min-width: auto;
                width: 350px;
                padding: 0 15px;
                flex-wrap: wrap;
                align-items: center;
                //margin: 0 -5px -5px 0;
                li {
                    margin: 5px;
                    height: 35px;
                    width: 35px;
                    background-size: contain;
                    padding: 0;
                    border-radius: 5px;
                    cursor: pointer;
                    background-repeat: no-repeat;
                }
            }

            &_checkboxes {
                .VFilter-dropdown-row {
                    list-style-type: none;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    padding: 5px;
                    position: relative;

                    &__option {
                        //max-width: 85px;
                        //overflow: hidden;
                        //text-overflow: ellipsis;
                        //text-transform: capitalize;
                    }

                    &__icon {
                        position: absolute;
                        right: 5px;
                        width: 15px;
                        height: 15px;
                        background-repeat: no-repeat;
                        background-size: contain;
                    }

                    ::v-deep .VCheckbox {
                        margin: 0 10px;
                    }
                }
            }
        }
    }

</style>
